import { questTable } from "../../helpers/tables";
import { queryOne, queryMany } from "./all";

const table = questTable;

const questModel = {
  getOneById: async (id) => {
    const data = await queryOne({ table, id });
    return data;
  },
  getMany: async (...args) => {
    const data = await queryMany({ table, conditions: [...args] });
    return data;
  },
  getManyByStoryworldId: async (storyworldId, ...args) => {
    const data = await queryMany({
      table,
      conditions: [["storyworld", "==", storyworldId], ...args],
    });
    return data;
  },
};

export default questModel;
